var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "newspaper",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.713,
    height: 47.856,
    viewBox: "0 0 51.713 47.856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M49.1,0H11.267a2.613,2.613,0,0,0-2.61,2.61V6.572H2.61A2.613,2.613,0,0,0,0,9.182V42.77a5.092,5.092,0,0,0,5.05,5.085H31.883a.758.758,0,1,0,0-1.515H8.7a5.07,5.07,0,0,0,1.468-3.571V25.055a.758.758,0,0,0-1.515,0V42.77A3.575,3.575,0,0,1,5.105,46.34H5.086a3.575,3.575,0,0,1-3.571-3.57V9.182a1.1,1.1,0,0,1,1.1-1.1H8.657v14.14a.758.758,0,1,0,1.515,0V2.61a1.1,1.1,0,0,1,1.095-1.1H49.1a1.1,1.1,0,0,1,1.1,1.1v40.16a3.575,3.575,0,0,1-3.571,3.571H34.711a.758.758,0,0,0,0,1.515H46.626a5.092,5.092,0,0,0,5.086-5.086V2.61A2.613,2.613,0,0,0,49.1,0Zm0,0",
    transform: "translate(0.001 0.001)",
    fill: "#494949"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M148.366,174.881h10.389a1.794,1.794,0,0,0,1.792-1.792V162.7a1.794,1.794,0,0,0-1.792-1.792H148.366a1.794,1.794,0,0,0-1.792,1.792v10.389A1.794,1.794,0,0,0,148.366,174.881Zm-.277-12.182a.277.277,0,0,1,.277-.277h10.389a.278.278,0,0,1,.277.277v10.389a.278.278,0,0,1-.277.277H148.366a.278.278,0,0,1-.277-.277Zm0,0",
    transform: "translate(-131.77 -144.655)",
    fill: "#494949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M305.449,162.421h14.059a.758.758,0,0,0,0-1.515H305.449a.758.758,0,0,0,0,1.515Zm0,0",
    transform: "translate(-273.917 -144.654)",
    fill: "#494949"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M305.449,224.1h14.059a.758.758,0,0,0,0-1.515H305.449a.758.758,0,0,0,0,1.515Zm0,0",
    transform: "translate(-273.917 -200.104)",
    fill: "#494949"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M305.449,285.777h14.059a.758.758,0,0,0,0-1.515H305.449a.758.758,0,0,0,0,1.515Zm0,0",
    transform: "translate(-273.917 -255.551)",
    fill: "#494949"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M147.332,347.453h30.029a.758.758,0,1,0,0-1.515H147.332a.758.758,0,1,0,0,1.515Zm0,0",
    transform: "translate(-131.77 -310.998)",
    fill: "#494949"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M147.332,409.132h30.029a.758.758,0,1,0,0-1.515H147.332a.758.758,0,1,0,0,1.515Zm0,0",
    transform: "translate(-131.77 -366.447)",
    fill: "#494949"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M146.766,46.779v-8A.408.408,0,0,1,147,38.4a1.157,1.157,0,0,1,.567-.13,1.2,1.2,0,0,1,.679.161,2,2,0,0,1,.518.69l2.38,4.6V38.763a.4.4,0,0,1,.234-.37,1.365,1.365,0,0,1,1.135,0,.4.4,0,0,1,.234.37v8.017a.412.412,0,0,1-.241.37,1.119,1.119,0,0,1-.561.136.963.963,0,0,1-.925-.506l-2.652-4.958v4.958a.412.412,0,0,1-.24.37,1.24,1.24,0,0,1-1.128,0,.412.412,0,0,1-.235-.37Zm0,0",
    transform: "translate(-131.942 -34.404)",
    fill: "#494949"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M220.645,46.779v-8a.42.42,0,0,1,.21-.37.887.887,0,0,1,.493-.136h4.391a.416.416,0,0,1,.376.21.9.9,0,0,1,.13.481.912.912,0,0,1-.136.506.42.42,0,0,1-.37.209h-3.49v2.467h1.875a.431.431,0,0,1,.37.191.758.758,0,0,1,.136.45.743.743,0,0,1-.13.426.426.426,0,0,1-.376.191h-1.875v2.479h3.49a.421.421,0,0,1,.37.209.913.913,0,0,1,.136.506.9.9,0,0,1-.13.481.415.415,0,0,1-.376.209h-4.391a.887.887,0,0,1-.493-.135.42.42,0,0,1-.21-.37Zm0,0",
    transform: "translate(-198.359 -34.404)",
    fill: "#494949"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M284.023,38.911a.54.54,0,0,1,.333-.45,1.368,1.368,0,0,1,.69-.191q.444,0,.53.321l1.949,6.685,1.048-4.292q.111-.444.789-.444t.777.444l1.048,4.292,1.949-6.685q.086-.321.531-.321a1.369,1.369,0,0,1,.69.191.54.54,0,0,1,.333.45.473.473,0,0,1-.024.148l-2.442,7.758q-.185.543-1.048.543a1.52,1.52,0,0,1-.666-.142.6.6,0,0,1-.358-.4l-.789-3.33-.8,3.33a.6.6,0,0,1-.358.4,1.52,1.52,0,0,1-.666.142,1.549,1.549,0,0,1-.678-.142.64.64,0,0,1-.37-.4l-2.442-7.758A.461.461,0,0,1,284.023,38.911Zm0,0",
    transform: "translate(-255.336 -34.404)",
    fill: "#494949"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M393.68,45.316a.961.961,0,0,1,.216-.574.61.61,0,0,1,.487-.29.632.632,0,0,1,.364.154,4.192,4.192,0,0,1,.395.339,1.811,1.811,0,0,0,.549.34,1.975,1.975,0,0,0,.789.153,1.7,1.7,0,0,0,.987-.271.909.909,0,0,0,.395-.8,1.076,1.076,0,0,0-.216-.66,1.716,1.716,0,0,0-.567-.481q-.351-.191-.771-.37t-.845-.4a4.924,4.924,0,0,1-.777-.5,2,2,0,0,1-.567-.74,2.463,2.463,0,0,1-.216-1.054,2.489,2.489,0,0,1,.265-1.171,2.017,2.017,0,0,1,.709-.789,3.317,3.317,0,0,1,.95-.413,4.251,4.251,0,0,1,1.073-.132,5.525,5.525,0,0,1,.678.045,6.273,6.273,0,0,1,.759.146,1.6,1.6,0,0,1,.653.316.648.648,0,0,1,.253.507,1.123,1.123,0,0,1-.172.568.525.525,0,0,1-.469.293,2.321,2.321,0,0,1-.6-.234,2.526,2.526,0,0,0-1.1-.234,1.789,1.789,0,0,0-1.03.253.827.827,0,0,0-.068,1.32,2.321,2.321,0,0,0,.734.432q.437.166.95.419a8.122,8.122,0,0,1,.95.549,2.3,2.3,0,0,1,.734.857,2.779,2.779,0,0,1,.3,1.314,2.423,2.423,0,0,1-.808,1.952,3.173,3.173,0,0,1-2.128.687,3.974,3.974,0,0,1-2.01-.481q-.839-.48-.839-1.048Zm0,0",
    transform: "translate(-353.918 -33.853)",
    fill: "#494949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.bd064c4e.svg";
export { ForwardRef as ReactComponent };